import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { LoggerModule as CosoLoggerModule } from "@coso/logger";
import { UtilityModule } from "@coso/utility";
import { AlertModule } from "ngx-bootstrap/alert";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PageHeaderModule } from "../../page-header/page-header.module";
import { BehaviorComponent } from "./behavior/behavior.component";
import { EntityFilterComponent } from "./entity-filter/entity-filter.component";
import { EventPriorityComponent } from "./event-priority/event-priority.component";
import { FailoverComponent } from "./failover/failover.component";
import { GeneralComponent } from "./general/general.component";
import { LogsComponent } from "./logs/logs.component";
import { MicrosoftTeamsComponent } from "./microsoft-teams/microsoft-teams.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { SecurityRoleFilterComponent } from "./security-role-filter/security-role-filter.component";
import { SettingsRoutingModule } from "./settings-routing.module";
import { SettingsComponent } from "./settings.component";
@NgModule({
    declarations: [
        SettingsComponent,
        GeneralComponent,
        BehaviorComponent,
        EntityFilterComponent,
        SecurityRoleFilterComponent,
        EventPriorityComponent,
        MicrosoftTeamsComponent,
        FailoverComponent,
        LogsComponent,
        NotificationsComponent
    ],
    imports: [
        CommonModule, 
        SettingsRoutingModule, 
        PageHeaderModule, 
        FormsModule, 
        AlertModule, 
        CosoLoggerModule, 
        CosoAlertModule, 
        UtilityModule, 
        TooltipModule, 
        ButtonsModule, 
        AlertMessageComponent,
    ]
})
export class SettingsModule {}
